function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { Close as CloseIcon } from '@mui/icons-material';
import { Alert, Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { constants } from '../constants';
import { UserAPI } from '../apis/UserAPI';
import { ConfigContext } from './ConfigContext';
var RoleModal = function RoleModal(_ref) {
    var _configState$settings, _configState$settings2, _configState$settings3, _configState$settings4;
    var open = _ref.open, onClose = _ref.onClose, onSave = _ref.onSave, role = _ref.role, loading = _ref.loading, _ref$applications = _ref.applications, applications = _ref$applications === void 0 ? [] : _ref$applications;
    var _useState = useState(''), _useState2 = _slicedToArray(_useState, 2), roleName = _useState2[0], setRoleName = _useState2[1];
    var _useState3 = useState([]), _useState4 = _slicedToArray(_useState3, 2), selectedPolicies = _useState4[0], setSelectedPolicies = _useState4[1];
    var _useState5 = useState([]), _useState6 = _slicedToArray(_useState5, 2), availablePolicies = _useState6[0], setAvailablePolicies = _useState6[1];
    var _useState7 = useState(false), _useState8 = _slicedToArray(_useState7, 2), policyLoading = _useState8[0], setPolicyLoading = _useState8[1];
    var _useState9 = useState(null), _useState0 = _slicedToArray(_useState9, 2), error = _useState0[0], setError = _useState0[1];
    var _useState1 = useState([]), _useState10 = _slicedToArray(_useState1, 2), selectedAppIds = _useState10[0], setSelectedAppIds = _useState10[1];
    var _React$useContext = React.useContext(ConfigContext), configState = _React$useContext.configState;
    var isEditMode = !!role;
    // Load available policies when modal opens
    useEffect(function () {
        if (open) {
            loadPolicies();
        }
    }, [open]);
    var loadPolicies = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            var response, _t;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.p = _context.n) {
                        case 0:
                            setPolicyLoading(true);
                            setError(null);
                            _context.p = 1;
                            _context.n = 2;
                            return UserAPI.getPolicies();
                        case 2:
                            response = _context.v;
                            setAvailablePolicies(response.resource);
                            _context.n = 4;
                            break;
                        case 3:
                            _context.p = 3;
                            _t = _context.v;
                            console.error('Failed to load policies:', _t);
                            setError(constants.role_modal_error_policies_load_failed);
                        case 4:
                            _context.p = 4;
                            setPolicyLoading(false);
                            return _context.f(4);
                        case 5:
                            return _context.a(2);
                    }
            }, _callee, null, [[1, 3, 4, 5]]);
        }));
        return function loadPolicies() {
            return _ref2.apply(this, arguments);
        };
    }();
    useEffect(function () {
        if (role) {
            setRoleName(role.name || role.role_name || '');
            setSelectedPolicies(role.policies || []);
            // Normalize application_id to string[] for default selection
            if (Array.isArray(role.application_id)) {
                setSelectedAppIds(role.application_id.map(String));
            }
            else if (role.application_id) {
                // If comma-separated string, split, else wrap as array
                if (typeof role.application_id === 'string' && role.application_id.includes(',')) {
                    setSelectedAppIds(role.application_id.split(',').map(function (id) {
                        return id.trim();
                    }));
                }
                else {
                    setSelectedAppIds([String(role.application_id)]);
                }
            }
            else {
                // Check if role has no application_id (null/undefined/empty)
                var hasNoApp = !role.application_id || Array.isArray(role.application_id) && role.application_id.every(function (id) {
                    return id === null || id === undefined || id === 'null';
                });
                setSelectedAppIds(hasNoApp ? ['none'] : []);
            }
        }
        else {
            setRoleName('');
            setSelectedPolicies([]);
            setSelectedAppIds([]);
        }
        setError(null);
    }, [role, open]);
    var handleAppChange = function handleAppChange(event) {
        var value = event.target.value;
        var newValue = typeof value === 'string' ? value.split(',') : value;
        // If 'none' is selected, clear other selections; if other is selected, remove 'none'
        if (newValue.includes('none') && !selectedAppIds.includes('none')) {
            setSelectedAppIds(['none']);
        }
        else if (newValue.includes('none') && newValue.length > 1) {
            setSelectedAppIds(newValue.filter(function (id) {
                return id !== 'none';
            }));
        }
        else {
            setSelectedAppIds(newValue);
        }
    };
    var handlePolicyChange = function handlePolicyChange(event) {
        var value = event.target.value;
        setSelectedPolicies(typeof value === 'string' ? value.split(',') : value);
    };
    var handleRemovePolicy = function handleRemovePolicy(policyToRemove) {
        setSelectedPolicies(function (prev) {
            return prev.filter(function (policy) {
                return policy !== policyToRemove;
            });
        });
    };
    var handleSave = function handleSave() {
        if (roleName.trim() && selectedAppIds.length > 0) {
            var _role$peopleAssigned, _role$dateAdded;
            var appIdsArray;
            if (selectedAppIds.includes('none')) {
                // If 'none' is selected, pass empty array to indicate no application
                appIdsArray = [];
            }
            else if (Array.isArray(selectedAppIds)) {
                appIdsArray = selectedAppIds;
            }
            else if (typeof selectedAppIds === 'string') {
                appIdsArray = [selectedAppIds];
            }
            else {
                appIdsArray = [];
            }
            var roleData = {
                name: roleName.trim(),
                role_name: roleName.trim(),
                role_key: roleName.trim().toLowerCase().replaceAll(/\s+/g, '_'),
                application_id: appIdsArray,
                policies: selectedPolicies,
                peopleAssigned: (_role$peopleAssigned = role === null || role === void 0 ? void 0 : role.peopleAssigned) !== null && _role$peopleAssigned !== void 0 ? _role$peopleAssigned : 0,
                dateAdded: (_role$dateAdded = role === null || role === void 0 ? void 0 : role.dateAdded) !== null && _role$dateAdded !== void 0 ? _role$dateAdded : new Date().toLocaleDateString()
            };
            onSave(roleData);
        }
    };
    var canSave = roleName.trim() && selectedAppIds.length > 0;
    var getButtonText = function getButtonText() {
        if (loading)
            return constants.saving;
        return isEditMode ? constants.configuration_modal_button_update : constants.configuration_modal_button_add;
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        maxWidth: "sm",
        fullWidth: true,
        sx: {
            '& .MuiDialog-paper': {
                borderRadius: 2,
                boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
                minHeight: 400
            }
        }
    }, /*#__PURE__*/ React.createElement(DialogTitle, {
        variant: "h6",
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb'
        }
    }, isEditMode ? constants.role_modal_title_edit((_configState$settings = configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.workspace_name) !== null && _configState$settings !== void 0 ? _configState$settings : constants.workspace_default_name) : constants.role_modal_title_add((_configState$settings3 = configState === null || configState === void 0 || (_configState$settings4 = configState.settings) === null || _configState$settings4 === void 0 ? void 0 : _configState$settings4.workspace_name) !== null && _configState$settings3 !== void 0 ? _configState$settings3 : constants.workspace_default_name)), /*#__PURE__*/ React.createElement(DialogContent, {
        sx: {
            p: '24px !important'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        }
    }, /*#__PURE__*/ React.createElement(FormControl, {
        fullWidth: true,
        size: "small",
        sx: {
            mb: 1
        }
    }, /*#__PURE__*/ React.createElement(InputLabel, null, constants.policy_mgmt_application_label), /*#__PURE__*/ React.createElement(Select, {
        multiple: true,
        value: selectedAppIds,
        onChange: handleAppChange,
        label: constants.policy_mgmt_application_label,
        renderValue: function renderValue(selected) {
            if (selected.includes('none')) {
                return 'Global Roles';
            }
            return applications.filter(function (app) {
                return selected.includes(String(app.id));
            }).map(function (app) {
                return app.name;
            }).join(', ');
        }
    }, /*#__PURE__*/ React.createElement(MenuItem, {
        value: "none"
    }, constants.global_roles), applications.map(function (app) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: app.id,
            value: String(app.id)
        }, app.name);
    }))), /*#__PURE__*/ React.createElement(TextField, {
        fullWidth: true,
        size: "small",
        label: constants.role_modal_field_role_name,
        value: roleName,
        onChange: function onChange(e) {
            return setRoleName(e.target.value);
        },
        required: true
    }), policyLoading ? /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            py: 2
        }
    }, /*#__PURE__*/ React.createElement(CircularProgress, {
        size: 20
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2"
    }, constants.role_modal_loading_policies)) : /*#__PURE__*/ React.createElement(FormControl, {
        fullWidth: true,
        size: "small"
    }, /*#__PURE__*/ React.createElement(InputLabel, null, constants.role_modal_policies_optional), /*#__PURE__*/ React.createElement(Select, {
        multiple: true,
        value: selectedPolicies,
        onChange: handlePolicyChange,
        label: constants.role_modal_policies_optional,
        renderValue: function renderValue() {
            return constants.role_modal_select;
        },
        disabled: availablePolicies.length === 0
    }, availablePolicies.map(function (policy) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: policy.id,
            value: policy.name
        }, policy.name);
    }))), error && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        sx: {
            mt: 1
        }
    }, error), selectedPolicies.length > 0 && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1
        }
    }, selectedPolicies.map(function (policy) {
        return /*#__PURE__*/ React.createElement(Chip, {
            key: policy,
            label: policy,
            onDelete: function onDelete() {
                return handleRemovePolicy(policy);
            },
            deleteIcon: /*#__PURE__*/ React.createElement(CloseIcon, null),
            sx: {
                backgroundColor: '#f3f8eb',
                color: '#1a5d09',
                fontSize: 12,
                fontWeight: 600,
                height: 24,
                '& .MuiChip-deleteIcon': {
                    color: '#1a5d09',
                    fontSize: 16,
                    '&:hover': {
                        color: '#26890d'
                    }
                }
            }
        });
    })))), /*#__PURE__*/ React.createElement(DialogActions, {
        sx: {
            px: 3,
            pb: 2,
            pt: 1,
            gap: 2,
            borderTop: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: onClose,
        disabled: loading,
        sx: {
            color: '#26890d',
            textTransform: 'none',
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: 16,
            px: 2,
            py: 1,
            '&:hover': {
                backgroundColor: 'rgba(38, 137, 13, 0.04)'
            }
        }
    }, constants.cancel), /*#__PURE__*/ React.createElement(Button, {
        onClick: handleSave,
        variant: "contained",
        disabled: loading || !canSave,
        sx: {
            backgroundColor: canSave ? '#26890d' : '#e0e0e0',
            color: canSave ? '#ffffff' : '#999',
            textTransform: 'none',
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: 16,
            px: 3,
            py: 1,
            '&:hover': {
                backgroundColor: canSave ? '#1f6b0a' : '#e0e0e0'
            },
            '&:disabled': {
                backgroundColor: '#e0e0e0',
                color: '#999'
            }
        }
    }, getButtonText())));
};
export default RoleModal;
